import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[caWidth]',
})
export class WidthDirective {
    private element: ElementRef;

    @Input() set caWidth(width: string) {
        this.element.nativeElement.style.width = width;
    }

    constructor(el: ElementRef) {
        this.element = el;
    }
}
